import { useState, useEffect, useCallback } from 'react';
import { contactPhone } from '@/mocks/homeData';

export default function FloatingCTA() {
  const [visible, setVisible] = useState(false);

  const handleScroll = useCallback(() => {
    setVisible(window.scrollY > 400);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const scrollToReservation = () => {
    const el = document.querySelector('#reservation');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-40 transition-all duration-500 ${
        visible
          ? 'translate-y-0 opacity-100'
          : 'translate-y-full opacity-0 pointer-events-none'
      }`}
    >
      <div className="bg-background-50/95 backdrop-blur-lg border-t border-background-200/60 shadow-[0_-4px_20px_rgba(0,0,0,0.06)]">
        <div className="w-full px-4 md:px-8 lg:px-12 max-w-6xl mx-auto py-3">
          <div className="flex items-center gap-3">
            <button
              type="button"
              onClick={scrollToReservation}
              className="flex-1 flex items-center justify-center gap-2 px-6 py-3.5 rounded-full bg-primary-500 text-background-50 text-base md:text-lg font-semibold whitespace-nowrap transition-all hover:bg-primary-600 active:scale-[0.98]"
            >
              <i className="ri-calendar-check-line text-lg" />
              방문예약
            </button>
            <a
              href={`tel:${contactPhone}`}
              className="flex-1 flex items-center justify-center gap-2 px-6 py-3.5 rounded-full bg-foreground-900 text-background-50 text-base md:text-lg font-semibold whitespace-nowrap transition-all hover:bg-foreground-800 active:scale-[0.98]"
            >
              <i className="ri-phone-line text-lg" />
              전화상담
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}